import React, { memo } from 'react'
import { Icon, Text } from 'common-components'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import UnlimitedBadge from './UnlimitedBadge'
import { CapabilityChips } from 'containers/SubSidebar/shared/GroupedModelDropdown'
import { getProviderInitials } from 'containers/SubSidebar/shared/GroupedModelDropdown/utils'
import RatingDots from '../RatingDots'
import CreditChip from '../CreditChip'
import InfoTooltip from './InfoTooltip'
import { IVideoModelGroup } from '../types'
import * as Styled from './styled'

interface IVideoGroupRowProps {
  group: IVideoModelGroup
  labels: string[]
  isActive: boolean
  isMultiVariant: boolean
  isPremium: boolean
  onClick: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  triggerRef: (el: HTMLDivElement | null) => void
}

const VideoGroupRow: React.FC<IVideoGroupRowProps> = ({
  group,
  labels,
  isActive,
  isMultiVariant,
  isPremium,
  onClick,
  onMouseEnter,
  onMouseLeave,
  triggerRef
}) => (
  <Styled.GroupItemWrapper
    ref={triggerRef}
    data-testid={`video-model-group-${group.key}`}
    $isActive={isActive}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <Styled.GroupRowFlex>
      <Styled.IconTile>
        {group.Icon ? (
          <Icon icon={<group.Icon />} customSize={24} />
        ) : (
          <Styled.ProviderIconFallback>
            {getProviderInitials(group.label)}
          </Styled.ProviderIconFallback>
        )}
      </Styled.IconTile>
      <Styled.GroupRowContent>
        <Styled.TitleLine>
          <Text type="subtitle" color="secondaryDark">
            {group.label}
          </Text>
          <InfoTooltip description={group.description} rating={group.rating} />
          {group.unlimitedOffer && (
            <UnlimitedBadge onClick={group.unlimitedOffer.onClick} />
          )}
          {isPremium && (
            <Icon icon={<CrownIcon />} customSize={15} color="goldDark" />
          )}
        </Styled.TitleLine>
        <Styled.MetaRow>
          {group.rating !== null && <RatingDots score={group.rating} />}
          <CapabilityChips labels={labels} />
          <CreditChip info={group.creditInfo} />
        </Styled.MetaRow>
      </Styled.GroupRowContent>
      {isMultiVariant && (
        <Styled.GroupChevron>
          <Icon icon={<ArrowDownIcon />} customSize={12} color="secondary" />
        </Styled.GroupChevron>
      )}
    </Styled.GroupRowFlex>
  </Styled.GroupItemWrapper>
)

export default memo(VideoGroupRow)
